import { useCallback, useState } from 'react';
import { CurrencyIcon } from '~/components/collections';
import { TextInput } from '~/components/ui/TextInput';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { setInputFocused, useLayoutDispatch } from '../../redux';
import { StyledContainer } from './MoneyInput.styled';

interface IMoneyInput {
	value: number;
	onChange: (newValue: number) => void;
}

const MoneyInput: React.FC<IMoneyInput> = ({ value, onChange }) => {
	const [inputValue, setInputValue] = useState<number>(value || 0);
	const dispatch = useLayoutDispatch();
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const inputValue = event.target.value.replace(/\D/g, '');

			if (inputValue.length === 0) {
				setInputValue(0);
				onChange(0);
				return;
			}

			setInputValue(parseInt(inputValue));
			onChange(parseInt(inputValue));
		},
		[],
	);

	return (
		<StyledContainer $active={inputValue > 0}>
			<TextInput
				height={50}
				fontSize={18}
				value={inputValue > 0 ? inputValue.toLocaleString('ru-RU') : ''}
				onChange={handleChange}
				placeholder={'Введите сумму продажи'}
				tabIndex={-1}
				style={{ padding: '0 60px 0 20px' }}
				onFocus={() => dispatch(setInputFocused(true))}
				onBlur={() => dispatch(setInputFocused(false))}
				active={inputValue > 0}
			/>
			<CurrencyIcon icon={rubleIcon} size="lg" />
		</StyledContainer>
	);
};

export { MoneyInput };
